<template>
  <div
    class="sikanii-profile-photo"
    style="cursor: pointer;"
    @click="downloadPhoto()"
  >
    <VDropdown
      v-if="photo && preview && $store.getters['app/isLargeScreen']"
      :distance="6"
      :triggers="['hover']"
      placement="right-end"
    >
      <b-avatar
        variant="light-primary"
        :size="size"
        :src="profilePhoto"
      />
      <template #popper>
        <div style="height: 300px;width: 250px;">
          <img
            style="object-fit: cover;"
            height="300px"
            width="250px"
            :src="profilePhoto"
          >
        </div>
      </template>
    </VDropdown>
    <b-avatar
      v-else
      :variant="variant"
      :size="size"
      :text="text"
      :src="profilePhoto"
    >
      <feather-icon :size="`${(+(size)/2)}`" :icon="icon" />
    </b-avatar>
  </div>
</template>

<script>
import { BAvatar, BTooltip, BCard } from 'bootstrap-vue'
import downloadFile from '@/libs/mixins/downloadFile'

export default {
  name: 'SikaniiProfilePhoto',
  components: {
    BAvatar,
    BTooltip,
    BCard,
  },
  mixins: [downloadFile],
  props: {
    photo: { type: String, default: null },
    icon: { type: String, default: null },
    text: { type: String, default: null },
    size: { type: String, default: '40' },
    variant: { type: String, default: 'light-primary' },
    preview: { type: Boolean, default: true },
    downloadable: { type: Boolean, default: false },
  },
  computed: {
    profilePhoto() {
      return `${process.env.VUE_APP_STORAGE_PATH}/${this.photo}`
    },
  },
  methods: {
    downloadPhoto() {
      if (this.downloadable) {
        this.downloadFile(this.photo, this.photo)
      }
    },
  },
}
</script>

<style scoped>

</style>
